import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";

import { Shared_FormTemplate_QuestionTypeSelectFragment } from "../fragments/fragmentsTypes.generated";
import { NarrowedFormField } from "../types";

type Props = {
    disabled?: boolean;
    field: NarrowedFormField<Shared_FormTemplate_QuestionTypeSelectFragment>;
    value?: string | null;
    onChange?: (value: string) => void;
};

export default function QuestionSelect({ disabled, field, value, onChange }: Props) {
    return (
        <Stack>
            <Typography>
                {field.name}
                {field.isRequired && (
                    <Typography component="span" sx={{ ml: 0.5 }}>
                        *
                    </Typography>
                )}
            </Typography>
            {field.description && <Typography variant="caption">{field.description}</Typography>}
            <RadioGroup value={value || ""} onChange={e => onChange?.(e.target.value)}>
                <Stack direction="column">
                    {field.type.options.map(({ id, key, name }) => (
                        <FormControlLabel
                            key={id}
                            value={key}
                            control={<Radio />}
                            label={name}
                            disabled={disabled || !onChange}
                            sx={{
                                "&.Mui-disabled": {
                                    opacity: 1,
                                },
                            }}
                        />
                    ))}
                </Stack>
            </RadioGroup>
        </Stack>
    );
}
